import * as React from "react";
import "./formGroup.scss";
import * as classNames from "classnames";
import {isNullOrUndefined} from "util";
import IconSmall from "../../atoms/Icon/IconSmall";

interface IProps {
	/**
	 * Form group label.
	 */
	label?: string | null;
	/**
	 * Error string.
	 */
	error?: string | null;
	/**
	 * Custom class for form group component.
	 */
	customClass?: string;
	/**
	 * Icon hover text
	 */
	iconTooltipText?: string;
	/**
	 * On icon click
	 */
	onIconClick?: () => void;
	/**
	 * Icon image
	 */
	icon?: string
}

export default class FormGroup extends React.Component<IProps, {}> {

	constructor(props: IProps) {
		super(props);
		this.renderLabel = this.renderLabel.bind(this);
		this.renderError = this.renderError.bind(this);
	}

	render() {
		const classFromProps = classNames({
			"m-form-group": true,
			[`${this.props.customClass}`]: !isNullOrUndefined(this.props.customClass)
		});
		return (
			<div className={classFromProps}>
				{this.renderLabel()}
				{this.props.children}
				{this.renderError()}
			</div>
		);
	}

	/**
	 * Render label with optional clickable icon
	 */
	renderLabel() {
		if (this.props.label) {
			return (
				<div className={"m-form-group_label-container"}>
					<label className={"m-form-group_label"}>{this.props.label}</label>
					{this.props.icon && <IconSmall customClass={"m-form-group_icon-container"}
												   icon={this.props.icon}
												   variant={"blue"}
												   iconTooltipText={this.props.iconTooltipText}
												   onClick={this.props.onIconClick}/>}
				</div>
			);
		}
	}

	renderError() {
		if (this.props.error) {
			return <label className={"m-form-group_error"}>{this.props.error}</label>;
		}
	}
}
